/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ProjectArchiveStateDto,
  ProjectCreateDto,
  ProjectListItemDto,
  ProjectUpdateDto,
  ProjectsControllerListProjectsParams
} from '../schemas';

import { customFetch } from '../../custom-fetch.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type projectsControllerListProjectsResponse200 = {
  data: ProjectListItemDto[]
  status: 200
}

export type projectsControllerListProjectsResponse401 = {
  data: void
  status: 401
}

export type projectsControllerListProjectsResponse403 = {
  data: void
  status: 403
}

export type projectsControllerListProjectsResponseSuccess = (projectsControllerListProjectsResponse200) & {
  headers: Headers;
};
export type projectsControllerListProjectsResponseError = (projectsControllerListProjectsResponse401 | projectsControllerListProjectsResponse403) & {
  headers: Headers;
};

export type projectsControllerListProjectsResponse = (projectsControllerListProjectsResponseSuccess | projectsControllerListProjectsResponseError)

export const getProjectsControllerListProjectsUrl = (params: ProjectsControllerListProjectsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/projects?${stringifiedParams}` : `/projects`
}

/**
 * Returns all projects owned by the given partner, ordered by project_name. Used to populate the Project dropdown in the Schedule Planner. Callers must be a member of the requested partner (admin emails bypass this check).
 * @summary List projects for a partner
 */
export const projectsControllerListProjects = async (params: ProjectsControllerListProjectsParams, options?: Parameters<typeof customFetch>[1]): Promise<projectsControllerListProjectsResponse> => {

  return customFetch<projectsControllerListProjectsResponse>(getProjectsControllerListProjectsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProjectsControllerListProjectsQueryKey = (params?: ProjectsControllerListProjectsParams,) => {
    return [
    `/projects`, ...(params ? [params] : [])
    ] as const;
    }


export const getProjectsControllerListProjectsQueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsControllerListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerListProjects>>> = ({ signal }) => projectsControllerListProjects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsControllerListProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerListProjects>>>
export type ProjectsControllerListProjectsQueryError = void


export function useProjectsControllerListProjects<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsControllerListProjects>>,
          TError,
          Awaited<ReturnType<typeof projectsControllerListProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsControllerListProjects<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof projectsControllerListProjects>>,
          TError,
          Awaited<ReturnType<typeof projectsControllerListProjects>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsControllerListProjects<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects for a partner
 */

export function useProjectsControllerListProjects<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerListProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List projects for a partner
 */
export const prefetchProjectsControllerListProjectsQuery = async <TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 queryClient: QueryClient, params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getProjectsControllerListProjectsQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}





export const getProjectsControllerListProjectsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProjectsControllerListProjectsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof projectsControllerListProjects>>> = ({ signal }) => projectsControllerListProjects(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProjectsControllerListProjectsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof projectsControllerListProjects>>>
export type ProjectsControllerListProjectsSuspenseQueryError = void


export function useProjectsControllerListProjectsSuspense<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsControllerListProjectsSuspense<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProjectsControllerListProjectsSuspense<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List projects for a partner
 */

export function useProjectsControllerListProjectsSuspense<TData = Awaited<ReturnType<typeof projectsControllerListProjects>>, TError = void>(
 params: ProjectsControllerListProjectsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof projectsControllerListProjects>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProjectsControllerListProjectsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type projectsControllerCreateProjectResponse201 = {
  data: void
  status: 201
}

export type projectsControllerCreateProjectResponseSuccess = (projectsControllerCreateProjectResponse201) & {
  headers: Headers;
};
;

export type projectsControllerCreateProjectResponse = (projectsControllerCreateProjectResponseSuccess)

export const getProjectsControllerCreateProjectUrl = () => {




  return `/projects`
}

export const projectsControllerCreateProject = async (projectCreateDto: ProjectCreateDto, options?: Parameters<typeof customFetch>[1]): Promise<projectsControllerCreateProjectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectsControllerCreateProjectResponse>(getProjectsControllerCreateProjectUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(projectCreateDto)
  }
);}





export const getProjectsControllerCreateProjectMutationKey = () => ['projectsControllerCreateProject'] as const;

export const getProjectsControllerCreateProjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerCreateProject>>, TError,ProjectsControllerCreateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerCreateProject>>, TError,ProjectsControllerCreateProjectMutationVariables, TContext> => {

const mutationKey = getProjectsControllerCreateProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerCreateProject>>, ProjectsControllerCreateProjectMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  projectsControllerCreateProject(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerCreateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerCreateProject>>>
    export type ProjectsControllerCreateProjectMutationBody = ProjectCreateDto
    export type ProjectsControllerCreateProjectMutationError = unknown
    export type ProjectsControllerCreateProjectMutationVariables = {data: ProjectCreateDto}

    export const useProjectsControllerCreateProject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerCreateProject>>, TError,ProjectsControllerCreateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsControllerCreateProject>>,
        TError,
        ProjectsControllerCreateProjectMutationVariables,
        TContext
      > => {
      return useMutation(getProjectsControllerCreateProjectMutationOptions(options), queryClient);
    }
    export type projectsControllerUpdateProjectResponse200 = {
  data: void
  status: 200
}

export type projectsControllerUpdateProjectResponseSuccess = (projectsControllerUpdateProjectResponse200) & {
  headers: Headers;
};
;

export type projectsControllerUpdateProjectResponse = (projectsControllerUpdateProjectResponseSuccess)

export const getProjectsControllerUpdateProjectUrl = (projectId: string,) => {




  return `/projects/${projectId}`
}

export const projectsControllerUpdateProject = async (projectId: string,
    projectUpdateDto: ProjectUpdateDto, options?: Parameters<typeof customFetch>[1]): Promise<projectsControllerUpdateProjectResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<projectsControllerUpdateProjectResponse>(getProjectsControllerUpdateProjectUrl(projectId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(projectUpdateDto)
  }
);}





export const getProjectsControllerUpdateProjectMutationKey = () => ['projectsControllerUpdateProject'] as const;

export const getProjectsControllerUpdateProjectMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerUpdateProject>>, TError,ProjectsControllerUpdateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerUpdateProject>>, TError,ProjectsControllerUpdateProjectMutationVariables, TContext> => {

const mutationKey = getProjectsControllerUpdateProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerUpdateProject>>, ProjectsControllerUpdateProjectMutationVariables> = (props) => {
          const {projectId,data} = props ?? {};

          return  projectsControllerUpdateProject(projectId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerUpdateProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerUpdateProject>>>
    export type ProjectsControllerUpdateProjectMutationBody = ProjectUpdateDto
    export type ProjectsControllerUpdateProjectMutationError = unknown
    export type ProjectsControllerUpdateProjectMutationVariables = {projectId: string;data: ProjectUpdateDto}

    export const useProjectsControllerUpdateProject = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerUpdateProject>>, TError,ProjectsControllerUpdateProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsControllerUpdateProject>>,
        TError,
        ProjectsControllerUpdateProjectMutationVariables,
        TContext
      > => {
      return useMutation(getProjectsControllerUpdateProjectMutationOptions(options), queryClient);
    }
    export type projectsControllerArchiveProjectResponse200 = {
  data: ProjectArchiveStateDto
  status: 200
}

export type projectsControllerArchiveProjectResponse401 = {
  data: void
  status: 401
}

export type projectsControllerArchiveProjectResponse403 = {
  data: void
  status: 403
}

export type projectsControllerArchiveProjectResponse404 = {
  data: void
  status: 404
}

export type projectsControllerArchiveProjectResponse409 = {
  data: void
  status: 409
}

export type projectsControllerArchiveProjectResponseSuccess = (projectsControllerArchiveProjectResponse200) & {
  headers: Headers;
};
export type projectsControllerArchiveProjectResponseError = (projectsControllerArchiveProjectResponse401 | projectsControllerArchiveProjectResponse403 | projectsControllerArchiveProjectResponse404 | projectsControllerArchiveProjectResponse409) & {
  headers: Headers;
};

export type projectsControllerArchiveProjectResponse = (projectsControllerArchiveProjectResponseSuccess | projectsControllerArchiveProjectResponseError)

export const getProjectsControllerArchiveProjectUrl = (projectId: string,) => {




  return `/projects/archive/${projectId}`
}

/**
 * Archives a project that has no work orders, or only draft or archived work orders (ENG-981). Any work order in redrafting, scheduled, in progress or complete blocks it with 409; the list endpoint reports that count up front as archive_blocking_work_order_count. Its work orders are left untouched. An archived project is read-only — every planner write returns 409 — and is hidden from project pickers until it is unarchived. Callers must be a member of the project partner (admins bypass this check).
 * @summary Archive a project
 */
export const projectsControllerArchiveProject = async (projectId: string, options?: Parameters<typeof customFetch>[1]): Promise<projectsControllerArchiveProjectResponse> => {

  return customFetch<projectsControllerArchiveProjectResponse>(getProjectsControllerArchiveProjectUrl(projectId),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getProjectsControllerArchiveProjectMutationKey = () => ['projectsControllerArchiveProject'] as const;

export const getProjectsControllerArchiveProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerArchiveProject>>, TError,ProjectsControllerArchiveProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerArchiveProject>>, TError,ProjectsControllerArchiveProjectMutationVariables, TContext> => {

const mutationKey = getProjectsControllerArchiveProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerArchiveProject>>, ProjectsControllerArchiveProjectMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  projectsControllerArchiveProject(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerArchiveProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerArchiveProject>>>

    export type ProjectsControllerArchiveProjectMutationError = void
    export type ProjectsControllerArchiveProjectMutationVariables = {projectId: string}

    /**
 * @summary Archive a project
 */
export const useProjectsControllerArchiveProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerArchiveProject>>, TError,ProjectsControllerArchiveProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsControllerArchiveProject>>,
        TError,
        ProjectsControllerArchiveProjectMutationVariables,
        TContext
      > => {
      return useMutation(getProjectsControllerArchiveProjectMutationOptions(options), queryClient);
    }
    export type projectsControllerUnarchiveProjectResponse200 = {
  data: ProjectArchiveStateDto
  status: 200
}

export type projectsControllerUnarchiveProjectResponse401 = {
  data: void
  status: 401
}

export type projectsControllerUnarchiveProjectResponse403 = {
  data: void
  status: 403
}

export type projectsControllerUnarchiveProjectResponse404 = {
  data: void
  status: 404
}

export type projectsControllerUnarchiveProjectResponse409 = {
  data: void
  status: 409
}

export type projectsControllerUnarchiveProjectResponseSuccess = (projectsControllerUnarchiveProjectResponse200) & {
  headers: Headers;
};
export type projectsControllerUnarchiveProjectResponseError = (projectsControllerUnarchiveProjectResponse401 | projectsControllerUnarchiveProjectResponse403 | projectsControllerUnarchiveProjectResponse404 | projectsControllerUnarchiveProjectResponse409) & {
  headers: Headers;
};

export type projectsControllerUnarchiveProjectResponse = (projectsControllerUnarchiveProjectResponseSuccess | projectsControllerUnarchiveProjectResponseError)

export const getProjectsControllerUnarchiveProjectUrl = (projectId: string,) => {




  return `/projects/unarchive/${projectId}`
}

/**
 * Restores an archived project exactly as it was archived, making it editable and selectable again (ENG-981). Callers must be a member of the project partner (admins bypass this check).
 * @summary Unarchive a project
 */
export const projectsControllerUnarchiveProject = async (projectId: string, options?: Parameters<typeof customFetch>[1]): Promise<projectsControllerUnarchiveProjectResponse> => {

  return customFetch<projectsControllerUnarchiveProjectResponse>(getProjectsControllerUnarchiveProjectUrl(projectId),
  {
    ...options,
    method: 'PATCH'


  }
);}





export const getProjectsControllerUnarchiveProjectMutationKey = () => ['projectsControllerUnarchiveProject'] as const;

export const getProjectsControllerUnarchiveProjectMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerUnarchiveProject>>, TError,ProjectsControllerUnarchiveProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof projectsControllerUnarchiveProject>>, TError,ProjectsControllerUnarchiveProjectMutationVariables, TContext> => {

const mutationKey = getProjectsControllerUnarchiveProjectMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof projectsControllerUnarchiveProject>>, ProjectsControllerUnarchiveProjectMutationVariables> = (props) => {
          const {projectId} = props ?? {};

          return  projectsControllerUnarchiveProject(projectId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProjectsControllerUnarchiveProjectMutationResult = NonNullable<Awaited<ReturnType<typeof projectsControllerUnarchiveProject>>>

    export type ProjectsControllerUnarchiveProjectMutationError = void
    export type ProjectsControllerUnarchiveProjectMutationVariables = {projectId: string}

    /**
 * @summary Unarchive a project
 */
export const useProjectsControllerUnarchiveProject = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof projectsControllerUnarchiveProject>>, TError,ProjectsControllerUnarchiveProjectMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof projectsControllerUnarchiveProject>>,
        TError,
        ProjectsControllerUnarchiveProjectMutationVariables,
        TContext
      > => {
      return useMutation(getProjectsControllerUnarchiveProjectMutationOptions(options), queryClient);
    }
